export default __webpack_public_path__ + "media/images/logos/logo_dark-db751dcadc556214e5a3301bccfa7a2e.png";